export const ASSET_TYPE_GROUPS = [
  { backendName: "Vehicle", labelKey: "assets.assetTypes.vehicle" },
  { backendName: "Trailer", labelKey: "assets.assetTypes.trailer" },
  { backendName: "Container", labelKey: "assets.assetTypes.container" },
  { backendName: "Equipment", labelKey: "assets.assetTypes.equipment" },
] as const;
